import {
  type GetTimesheetResponse,
  TimesheetArbeitszeitDayTypeEnum,
  TimesheetArbeitszeitStatusEnum,
  TimesheetArbeitszeitTimeSlotTypeEnum,
} from '@omnipresentgroup/types';

export const DEFAULT_TIMESHEET: GetTimesheetResponse = {
  startDate: '2024-04-29',
  employeeId: 'def2967b-f6fa-48a7-82f0-cf56ecd8b5a7',
  id: '8cccdf28-c2ca-4dc3-bac3-8a0e00a5916c',
  days: [
    {
      date: '2024-04-29',
      type: TimesheetArbeitszeitDayTypeEnum.WORKDAY,
      timeSlots: [
        {
          type: TimesheetArbeitszeitTimeSlotTypeEnum.WORK,
          startTime: '2024-04-29T13:00',
          endTime: '2024-04-29T14:00',
        },
        {
          type: TimesheetArbeitszeitTimeSlotTypeEnum.PARENTAL_LEAVE,
          startTime: '2024-04-29T14:00',
          endTime: '2024-04-29T15:00',
        },
        {
          type: TimesheetArbeitszeitTimeSlotTypeEnum.BREAK,
          startTime: '2024-04-29T15:00',
          endTime: '2024-04-29T15:30',
        },
        {
          type: TimesheetArbeitszeitTimeSlotTypeEnum.WORK,
          startTime: '2024-04-29T15:30',
          endTime: '2024-04-29T18:00',
        },
      ],
      summary: {
        [TimesheetArbeitszeitTimeSlotTypeEnum.WORK]: 'PT3H',
        [TimesheetArbeitszeitTimeSlotTypeEnum.BREAK]: 'PT30M',
        [TimesheetArbeitszeitTimeSlotTypeEnum.PARENTAL_LEAVE]: 'PT1H',
      },
    },
    {
      date: '2024-04-30',
      type: TimesheetArbeitszeitDayTypeEnum.WORKDAY,
      timeSlots: [
        {
          type: TimesheetArbeitszeitTimeSlotTypeEnum.WORK,
          startTime: '2024-04-30T09:00',
          endTime: '2024-04-30T15:15',
        },
        {
          type: TimesheetArbeitszeitTimeSlotTypeEnum.BREAK,
          startTime: '2024-04-30T15:15',
          endTime: '2024-04-30T16:00',
        },
      ],
      summary: {
        [TimesheetArbeitszeitTimeSlotTypeEnum.WORK]: 'PT6H15M',
        [TimesheetArbeitszeitTimeSlotTypeEnum.BREAK]: 'PT6H45M',
      },
    },
    {
      date: '2024-05-01',
      type: TimesheetArbeitszeitDayTypeEnum.PUBLIC_HOLIDAY,
      timeSlots: [],
    },
    {
      date: '2024-05-02',
      type: TimesheetArbeitszeitDayTypeEnum.WORKDAY,
      timeSlots: [],
    },
    {
      date: '2024-05-03',
      type: TimesheetArbeitszeitDayTypeEnum.WORKDAY,
      timeSlots: [],
    },
    {
      date: '2024-05-04',
      type: TimesheetArbeitszeitDayTypeEnum.WEEKEND,
      timeSlots: [],
    },
    {
      date: '2024-05-05',
      type: TimesheetArbeitszeitDayTypeEnum.WEEKEND,
      timeSlots: [],
    },
  ],
  endDate: '2024-05-05',
  status: {
    type: TimesheetArbeitszeitStatusEnum.DRAFT,
    updatedAt: '2024-05-03T14:59:44.895Z',
    updatedBy: '82e11408-5cd4-4ce1-8d54-73622f4930b5',
    detail: 'Please provide more details',
  },
  summary: {
    [TimesheetArbeitszeitTimeSlotTypeEnum.WORK]: 'PT9H15M',
    [TimesheetArbeitszeitTimeSlotTypeEnum.BREAK]: 'PT1H15M',
    [TimesheetArbeitszeitTimeSlotTypeEnum.PARENTAL_LEAVE]: 'PT1H',
  },
};
